import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useClient from 'api/client';
import getSqlPipelineCredsLinux from 'api/SqlPipeline/getSqlPipelineCredsLinux';
import { useAlert } from 'components/message/AlertContext';
import formatCredentials, {
    FormatType,
} from 'components/modal/CredentialsModal/FormatCredentials';
import { Credential } from 'types/Credentials';

export default function usePipelineCreds(onClose: () => void) {
    const client = useClient();
    const params = useParams();
    const { openAlert } = useAlert();
    const [script, setScript] = useState<Credential[]>([
        { key: '', value: '' },
    ]);
    const [copyCredentials, setCopyCredentials] = useState<string[]>([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (client) {
            setLoading(true);
            client
                .query(getSqlPipelineCredsLinux(params.uri))
                .then((response: any) => {
                    if (response.errors) {
                        openAlert({
                            message: 'Error fecthing pipeline credentials',
                            severity: 'alert',
                        });
                        onClose();
                        setLoading(false);
                    } else {
                        const inputString =
                            response.data.getSqlPipelineCredsLinux;
                        const formattedScript = formatCredentials(
                            inputString,
                            FormatType.Script,
                        );
                        setCopyCredentials([formattedScript as string]);

                        const formattedObject = formatCredentials(
                            inputString,
                            FormatType.Object,
                        );
                        setScript(formattedObject as Credential[]);

                        setLoading(false);
                    }
                });
        }
    }, [client, params.uri, setLoading]);

    return { script, copyCredentials, loading };
}
